<template>
  <form-layout>
    <template slot="heading">
      <h5>パスワードのリセット</h5>
    </template>
    <Reset/>
  </form-layout>
</template>

<script>
import FormLayout from '@/views/FormLayout.vue';
import Reset from '@/components/auth/Reset.vue';

export default {
  name: 'ResetPassword',
  components: { FormLayout, Reset },
};
</script>

<style scoped>

</style>
